import { User } from '@sr/types';
import { ref, get, update } from 'firebase/database';
import Cookies from 'js-cookie';
import trackEvent from 'utils/analytics';
import { db } from 'utils/firebase/database';
import isBot from 'utils/is-bot';

export function getUserRef(userId: string) {
  return ref(db, `users2/${userId}`);
}

export async function getUser(userId: string) {
  const ref = getUserRef(userId);
  const snap = await get(ref);
  if (snap.exists()) {
    return snap.val() as User;
  } else {
    return null;
  }
}

export async function createUser(userId: string) {
  const trackingInfo = getTrackingInfo();
  const newUser: User = {
    id: userId,
    isAnonymous: true,
    dateCreated: new window.Date().getTime(),
    isBot: isBot(),
    ...trackingInfo,
  };
  await updateUser(userId, newUser);
  trackEvent.signedUp({
    referredBy: trackingInfo.referredBy,
    userId,
  });
  return newUser;
}

export function updateUser(userId: string, updates: Partial<User>) {
  const ref = getUserRef(userId);
  return update(ref, updates);
}

type TrackingInfo = { referredBy?: string; referredByAffiliateId?: string };
function getTrackingInfo(): TrackingInfo {
  const info: TrackingInfo = {};

  // Add referral code if present
  const referralId = Cookies.get('referralId');
  if (referralId) {
    info.referredBy = referralId;
  }

  // Add affiliate code if present
  const affiliateId = Cookies.get('affiliateId');
  if (affiliateId) {
    info.referredByAffiliateId = affiliateId;
  }

  return info;
}

// Update referral and affiliate data based on cookie values
export function updateUserTrackingInfo(userId: string) {
  return updateUser(userId, getTrackingInfo());
}
